import setCookie from './utils/setCookie';

/**
 * A custom element for enhancing a static disclaimer message into one that allows the user to dismiss it.
 *
 * @module iabbb-outage-disclaimer
 */
class OutageDisclaimer extends HTMLElement {
  constructor() {
    super();

    this.render = () => {
      this.addCloseButton();
    };
  }

  connectedCallback() {
    this.render();
  }

  addCloseButton = () => {
    const closeIcon = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" aria-hidden="true" fill="currentColor" focusable="false" height="1em" width="1em"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3l105.4 105.3c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256l105.3-105.4z"></path></svg>`;
    const visuallyHiddenLabel = `<span class="visually-hidden">close outage disclaimer</span>`;

    const closeButton = document.createElement('button');
    closeButton.className = 'bds-button-unstyled';
    closeButton.innerHTML = `${closeIcon}${visuallyHiddenLabel}`;

    closeButton.onclick = () => {
      this.addDisclaimerAcknowledgedCookie();
      this.style.display = 'none';
    };

    this.appendChild(closeButton);
  };

  addDisclaimerAcknowledgedCookie = () => {
    setCookie('iabbb_outage_disclaimer', 'true');
  };
}

customElements.define('iabbb-outage-disclaimer', OutageDisclaimer);
